import { objectOf, maybe } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdSurveyStatsResult = objectOf({
  completions: number,
  partial_completions: number,
  clicks: number,
  impressions: number,
  unique_impressions: maybe(number),
});
